<template>
  <div class="form-content">
    <!-- <div class="form-tab">
      <el-tabs v-model="activeName" stretch>
        <el-tab-pane label="星云系统登录" name="SYS"></el-tab-pane>
        <el-tab-pane label="纵腾内网登录" name="CAS"></el-tab-pane>
        <el-tab-pane label="域账户登录" name="LDAP"></el-tab-pane>
      </el-tabs>
    </div> -->
    <LoginForm :type="activeName" />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
// import { useStore } from 'vuex'
import LoginForm from './LoginForm'

export default defineComponent({
  name: 'LoginFormContent',
  components: {
    LoginForm
  },
  setup() {
    // const store = useStore()
    // 计算用户源开关状态
    // 根据环境配置中的 UserSourceSwitch 字段决定 activeName 的值，开启时为 'AMS'，否则为 'SYS'
    // const activeName = computed(() => {
    //   return store.state.env.amsConfig?.UserSourceSwitch ? 'AMS' : 'SYS'
    // })
    const activeName = ref('AMS')

    return {
      activeName
    }
  }
})
</script>

<style lang="scss" scoped>
.form-content {
  padding: 0 35px;
  box-sizing: border-box;

  .form-tab {
    // padding: 0 25px;

    :deep(.el-tabs__item) {
      font-weight: 700;
      padding: 0;
    }

    :deep(.el-tabs__nav-wrap::after) {
      background-color: transparent;
    }
  }

  :deep(.el-tabs__nav-scroll) {
    margin: 0;

    // .el-tabs__active-bar {
    //   width: 33%!important;
    // }
  }
}
</style>
